import { useDecisionMakerResponsePageData } from '#src/app/pages/decisionMaker/response/details/pageContext';
import type { ShareAction, ShareActionsOptions } from '#src/app/shared/hooks/share';
import { useShareActions } from '#src/app/shared/hooks/share';

import type { Channel } from './types';
import { useShareOptions } from './useShareOptions';

type Result = ModelHookResult<{
	shareActions: ReadonlyArray<ShareAction<Channel>>;
}>;

export function useShareLinks(): Result {
	const options = useShareOptions();
	const {
		data: {
			decisionMakerResponse: { shareLinks },
		},
	} = useDecisionMakerResponsePageData();

	return {
		data: {
			shareActions: useShareActions(shareLinks.links, options as ShareActionsOptions) as ReadonlyArray<
				ShareAction<Channel>
			>,
		},
	};
}

export type { Channel };
